export const MAX_INDIVIDUAL_BRANDS = 10;

export const MAX_BRANDS_MESSAGE = `Maximum ${MAX_INDIVIDUAL_BRANDS} brands can be selected. Select 'All Brands' if you need more`;

export const WILDCARD_DESELECT_MESSAGE = `You currently have more than ${MAX_INDIVIDUAL_BRANDS} brands selected. You can select 'All Brands' or a maximum of ${MAX_INDIVIDUAL_BRANDS} individual brands`;
